<!-- ═══════════════════════════════════════════════════════════════
     Shaji AI — floating chat widget
     Hidden when not logged in, or when already on the full-page route.
     ═══════════════════════════════════════════════════════════════ -->

<!-- Big animated welcome popup — shown right after login (any page). -->
<div class="sw-hello-backdrop" *ngIf="welcomeVisible && isLoggedIn" (click)="dismissWelcome()">
  <div class="sw-hello-card" (click)="$event.stopPropagation()">
    <button class="sw-hello-x" (click)="dismissWelcome()" aria-label="Close">×</button>
    <div class="sw-hello-orb">
      <span class="sw-hello-ring"></span>
      <span class="sw-hello-ring r2"></span>
      <img src="assets/img/shaji-brand.png" alt="Shaji AI" />
    </div>
    <h1 class="sw-hello-title">Hey {{ welcomeFirstName }}! 👋</h1>
    <p class="sw-hello-greet">{{ welcomeGreeting }} {{ welcomeEmoji }}</p>
    <p class="sw-hello-sub">{{ welcomeSubline }}</p>
    <button class="sw-hello-cta" (click)="openAiFromWelcome()">
      <img src="assets/img/shaji-brand.png" alt="" />
      <span>Ask Shaji AI</span>
    </button>
    <button class="sw-hello-later" (click)="dismissWelcome()">Maybe later</button>
  </div>
</div>

<ng-container *ngIf="isLoggedIn && !onFullPage">

  <div class="sw-host">

    <!-- Backdrop (expanded only) -->
    <div class="sw-backdrop" [attr.data-show]="isOpen && isExpanded" (click)="isExpanded = false"></div>

    <!-- Launcher bubble -->
    <button
      class="sw-launcher"
      [attr.data-open]="isOpen"
      (click)="open()"
      title="Open Shaji AI"
      aria-label="Open Shaji AI">
      <img src="assets/img/shaji-brand.png" alt="Shaji AI" />
      <span class="sw-badge" *ngIf="unread > 0 && !isOpen">{{ unread }}</span>
    </button>

    <!-- Panel (compact or expanded) -->
    <div class="sw-panel" *ngIf="isOpen" [attr.data-open]="isOpen" [attr.data-expanded]="isExpanded">

      <!-- Report status toast (auto-dismisses) -->
      <div class="report-toast" *ngIf="reportToast" [attr.data-type]="reportToast.type">{{ reportToast.text }}</div>

      <!-- Report-an-issue popup: ask the user to describe the problem before sending. -->
      <div class="report-modal-backdrop" *ngIf="reportModalOpen" (click)="cancelReport()">
        <div class="report-modal" (click)="$event.stopPropagation()">
          <div class="report-modal-head">
            <span>Report an issue</span>
            <button class="report-modal-x" (click)="cancelReport()" title="Close">×</button>
          </div>
          <p class="report-modal-sub">Tell us what went wrong, in detail — what you asked, what you expected, and what actually happened. Your screen and this chat are attached automatically.</p>
          <textarea class="report-modal-text"
                    [(ngModel)]="reportText"
                    rows="5"
                    maxlength="4000"
                    placeholder="e.g. The sales total for Allied Trading looked too low…"></textarea>
          <div class="report-modal-actions">
            <button class="report-btn-cancel" (click)="cancelReport()">Cancel</button>
            <button class="report-btn-send" [disabled]="!reportText.trim()" (click)="submitReport()">Send report</button>
          </div>
        </div>
      </div>

      <!-- Header -->
      <div class="sw-head">
        <div class="sw-id">
          <div class="sw-mark"><img src="assets/img/shaji-brand.png" alt="Shaji" /></div>
          <div class="sw-name-row">
            <div class="sw-name">Shaji AI</div>
            <div class="sw-status">
              <span class="dot"></span>
              <span>Online · usually replies instantly</span>
            </div>
          </div>
        </div>
                <div class="sw-head-actions">
                    <div [title]="quotaUnlimited ? 'Token usage: unlimited' : 'Token usage: ' + quotaPercent + '%'" style="position:relative;width:22px;height:22px;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
            <svg width="22" height="22" viewBox="0 0 22 22" style="transform:rotate(-90deg)">
              <circle cx="11" cy="11" r="9" fill="none" stroke="#e5e7eb" stroke-width="2.5"></circle>
              <circle *ngIf="!quotaUnlimited" cx="11" cy="11" r="9" fill="none" [attr.stroke]="quotaPercent >= 90 ? '#dc2626' : '#16a34a'" stroke-width="2.5" stroke-linecap="round" [attr.stroke-dasharray]="quotaRingCircumference" [attr.stroke-dashoffset]="quotaRingOffset"></circle>
            </svg>
            <span *ngIf="!quotaUnlimited" style="position:absolute;font-size:7px;font-weight:600;color:#374151;">{{ quotaPercent }}</span>
                        <svg *ngIf="quotaUnlimited" width="13" height="8" viewBox="0 0 26 16" style="position:absolute;" fill="none" stroke="#6b7280" stroke-width="2.2">
              <circle cx="7" cy="8" r="5.5"></circle>
              <circle cx="19" cy="8" r="5.5"></circle>
            </svg>
                  </div>
          <button class="sw-iconbtn" (click)="openReportPanel()" [disabled]="isReporting" title="Report an issue" aria-label="Report an issue">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 22V4a2 2 0 0 1 2-2h11l1 4h3v8h-7l-1-4H6"/>
            </svg>
          </button>
          <button class="sw-iconbtn" (click)="isExpanded = !isExpanded" [title]="isExpanded ? 'Collapse' : 'Expand'" [attr.aria-label]="isExpanded ? 'Collapse' : 'Expand'">
            <span class="icon-stack">
              <span [attr.data-show]="!isExpanded" style="display:block">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7"/>
                </svg>
              </span>
              <span [attr.data-show]="isExpanded" style="display:block">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M9 4v5H4M15 20v-5h5M9 9 4 4M15 15l5 5"/>
                </svg>
              </span>
            </span>
          </button>
          <button class="sw-iconbtn" (click)="minimize()" title="Minimize" aria-label="Minimize">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"/>
            </svg>
          </button>
          <button class="sw-iconbtn" (click)="close()" title="Close" aria-label="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 6l12 12M18 6 6 18"/>
            </svg>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="sw-body">

        <!-- History rail (expanded only) -->
        <aside class="sw-rail">
          <div class="sw-rail-head">
            <span>Conversations</span>
            <button (click)="newChat()" aria-label="New chat" title="New chat">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 5v14M5 12h14"/>
              </svg>
            </button>
          </div>
          <div class="sw-rail-list">
            <ng-container *ngFor="let group of sessionGroups">
              <div class="sw-rail-group">{{ group.label }}</div>
              <div *ngFor="let s of group.sessions"
                      class="sw-rail-item"
                      [attr.data-active]="s.session_id === currentSessionId"
                      (click)="openSession(s)"
                      [title]="s.title"
                      role="button" tabindex="0">
                <div class="sw-rail-item-main">
                  <div class="sw-rail-item-title">{{ s.title }}</div>
                  <div class="sw-rail-item-time">{{ state.relativeTime(s.updatedAt) }} ago</div>
                </div>
                <div class="sw-rail-actions">
                  <button type="button" class="sw-rail-act" title="Rename chat" aria-label="Rename chat" (click)="renameChat(s, $event)">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                  </button>
                  <button type="button" class="sw-rail-act danger" title="Delete chat" aria-label="Delete chat" (click)="deleteChat(s, $event)">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                  </button>
                </div>
              </div>
            </ng-container>
            <div *ngIf="sessionGroups.length === 0" style="padding: 18px 12px; color: var(--text-faint); font-size: 12px; text-align: center;">
              No previous chats yet
            </div>
          </div>
          <div class="sw-rail-foot">
            <div class="sb-avatar">{{ initials }}</div>
            <span>{{ employeeName }}</span>
          </div>
        </aside>

        <!-- Main thread + composer -->
        <div class="sw-main">

          <div class="sw-thread" #threadEl (scroll)="onThreadScroll()">
            <div class="sw-thread-inner">

              <!-- Welcome (empty state) -->
              <ng-container *ngIf="showWelcome">
                <div class="sw-welcome">
                  <h2 class="sw-welcome-hd">Hi {{ firstName }}, I'm <em>Shaji AI</em>.<br />What's on your mind?</h2>
                  <p class="sw-welcome-sub">Ask me about sales, customers, inventory, attendance — anything across the ERP. I'll stream back.</p>
                  <div class="sw-quick">
                    <button class="sw-quick-btn" *ngFor="let q of quickPrompts" (click)="selectSuggestion(q.ask)">
                      <svg *ngIf="q.icon === 'chart'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 14l4-4 4 4 5-6"/></svg>
                      <svg *ngIf="q.icon === 'users'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="7" r="4"/><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                      <svg *ngIf="q.icon === 'inventory'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16zM3.27 6.96 12 12.01l8.73-5.05M12 22.08V12"/></svg>
                      <svg *ngIf="q.icon === 'bulb'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 22h4M12 2a6 6 0 0 0-4 10.5c1 .9 2 2 2 3.5h4c0-1.5 1-2.6 2-3.5A6 6 0 0 0 12 2z"/></svg>
                      <span>{{ q.title }}</span>
                      <svg class="arrow" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Messages -->
              <ng-container *ngIf="!showWelcome">
                <ng-container *ngFor="let msg of messages; let i = index; trackBy: trackByIndex">

                  <!-- AI -->
                  <div class="sw-msg" data-role="ai" *ngIf="msg.role === 'ai'" [style.--msg-i]="i">
                    <div class="sw-avatar ai" [class.thinking]="!msg.finalized"><img src="assets/img/shaji-brand.png" alt="" /></div>
                    <div style="flex:1; min-width:0; max-width:100%;">
                      <div class="sw-bubble">

                        <!-- Live progress — box-less, the real current step updating live (the
                             single animated icon is the message avatar on the left, which blinks). -->
                        <div class="sw-think" *ngIf="!msg.finalized && !msg.text" aria-live="polite">
                          <span class="sw-think-text">{{ (state.thinkingDisplay$ | async) }}<i class="sw-think-caret"></i></span>
                          <span class="sw-think-time">{{ elapsedSecs }}s</span>
                        </div>

                        <!-- Finished — subtle one-liner (no box), tap to see the steps it took -->
                        <div class="sw-done" *ngIf="msg.finalized && msg.steps && msg.steps.length > 0">
                          <button class="sw-done-toggle" (click)="toggleSteps(i)" [attr.aria-expanded]="msg.stepsOpen">
                            <span class="sw-done-check">✓</span>
                            <span>Done in {{ state.formatDuration(msg.processingDuration) }}</span>
                            <span class="sw-done-count">· {{ msg.steps.length }} step{{ msg.steps.length !== 1 ? 's' : '' }}</span>
                            <span class="sw-done-chev">{{ msg.stepsOpen ? '▾' : '▸' }}</span>
                          </button>
                          <div class="sw-done-steps" *ngIf="msg.stepsOpen">
                            <div class="sw-step" *ngFor="let step of msg.steps">
                              <span class="sw-step-dot done">✓</span>
                              <span>{{ step }}</span>
                            </div>
                          </div>
                        </div>

                        <!-- Chart -->
                        <div class="sw-chart" *ngIf="msg.chartData && msg.chartOptions">
                          <div class="sw-chart-title" *ngIf="msg.chartData.title">{{ msg.chartData.title }}</div>
                          <!-- Chart-type switcher toolbar (above chart) -->
                          <div class="chart-types">
                            <button *ngFor="let t of availableChartTypes(msg.chartData?.type)"
                                    class="chart-type-btn"
                                    [class.active]="msg.chartData?.type === t.id"
                                    (click)="switchChartType(i, t.id)"
                                    [title]="t.label"
                                    [attr.aria-label]="t.label">
                              <span class="chart-type-icon">{{ t.icon }}</span>
                            </button>
                          </div>
                          <div echarts [options]="msg.chartOptions" [autoResize]="true"
                               [style.height]="isExpanded ? '320px' : '220px'"
                               style="width: 100%;"></div>
                        </div>

                        <!-- Visit heat-map (getVisitMap) -->
                        <div class="sw-map" *ngIf="msg.mapData">
                          <div class="sw-map-title">🗺️ {{ msg.mapData.title || 'Visit map' }}</div>
                          <div class="sw-map-canvas" [visitMap]="msg.mapData"></div>
                          <div class="sw-map-legend">{{ msg.mapData.caption || ('Hotter zones = more visits · tap a pin for the customer · ' + (msg.mapData.totals?.customers || 0) + ' customers · ' + (msg.mapData.totals?.visits || 0) + ' visits') }} · ⛶ full screen · ⤓ download (top-left)</div>
                        </div>

                        <!-- Text -->
                        <span *ngIf="msg.text" class="ai-msg-text"
                              [innerHTML]="state.formatMessage(msg.text, !msg.finalized)"
                              (click)="onMessageClick($event, msg)"></span>
                        <span *ngIf="msg.typing && msg.text" class="sw-caret"></span>

                        <!-- Generated document downloads (createDocument) -->
                        <div class="sw-files" *ngIf="msg.files?.length">
                          <a class="sw-file-card" *ngFor="let f of msg.files"
                             [href]="state.resolveFileUrl(f.url)" target="_blank" rel="noopener" download>
                            <span class="sw-file-icon" [attr.data-fmt]="f.format">{{ state.fileEmoji(f.format) }}</span>
                            <span class="sw-file-meta">
                              <span class="sw-file-name">{{ f.name }}</span>
                              <span class="sw-file-sub">{{ state.fileLabel(f.format) }} · {{ f.sizeKb }} KB · Tap to download</span>
                            </span>
                            <svg class="sw-file-dl" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                          </a>
                        </div>

                        <!-- Read aloud (TTS) -->
                        <button type="button"
                                *ngIf="speechSupported && msg.finalized && msg.text"
                                class="speak-btn"
                                [class.speaking]="currentSpeakingIndex === i && isSpeaking"
                                [title]="currentSpeakingIndex === i && isSpeaking ? 'Stop' : 'Read aloud'"
                                (click)="toggleSpeak(msg.text, i)">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/>
                            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>
                          </svg>
                        </button>

                        <!-- Copy answer (managers paste totals into WhatsApp/email) -->
                        <button type="button"
                                *ngIf="msg.finalized && msg.text"
                                class="speak-btn"
                                [class.speaking]="copiedIdx === i"
                                [title]="copiedIdx === i ? 'Copied!' : 'Copy answer'"
                                (click)="copyMsg(i, msg.text)">
                          <svg *ngIf="copiedIdx !== i" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                          </svg>
                          <svg *ngIf="copiedIdx === i" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        </button>

                        <!-- Regenerate — re-ask the last question for a fresh answer (only on the latest reply) -->
                        <button type="button"
                                *ngIf="msg.finalized && msg.text && i === messages.length - 1 && !isStreaming && !isLoading"
                                class="speak-btn"
                                title="Regenerate this answer"
                                (click)="regenerate()">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M23 4v6h-6M1 20v-6h6"/>
                            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- User -->
                  <div class="sw-msg" data-role="user" *ngIf="msg.role === 'user'" [style.--msg-i]="i">
                    <div class="sw-bubble">
                      <span *ngIf="msg.screenAttached" class="sw-screen-chip" title="Your current screen was attached to this message">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                        Screen attached
                      </span>
                      {{ msg.text }}
                    </div>
                    <div class="sw-avatar user">{{ initials }}</div>
                  </div>

                  <!-- Delivery failure + one-tap retry (was missing in the widget — a failed send used to vanish silently) -->
                  <div *ngIf="msg.role === 'user' && msg.delivery === 'failed'"
                       style="display:flex;align-items:center;gap:8px;justify-content:flex-end;margin:-2px 46px 6px 0;font-size:12px;color:#dc2626;">
                    <span>Couldn't send{{ msg.deliveryError ? ' · ' + msg.deliveryError : '' }}</span>
                    <button type="button" (click)="state.retryFailedMessage(i, userType, employeeName)"
                            style="border:1px solid #dc2626;color:#dc2626;background:transparent;border-radius:10px;padding:2px 10px;font-size:11px;cursor:pointer;">↻ Retry</button>
                  </div>

                </ng-container>
              </ng-container>

            </div>
          </div>

          <!-- Jump-to-latest pill: appears when you've scrolled up while a reply streams -->
          <button type="button" class="sw-jump" *ngIf="showJumpBtn" (click)="jumpToLatest()" aria-label="Jump to latest">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
            <span>Latest</span>
          </button>

          <!-- Composer (chips sit in normal flow above composer to avoid overlap) -->
          <div class="sw-composer-wrap">

            <!-- Voice listening popup — floats above the composer while mic is hot.
                 Different colour/message depending on which mic was pressed. -->
            <div class="voice-popup" *ngIf="isListening" [class.product]="productVoiceActive" role="status" aria-live="polite">
              <button type="button" class="voice-popup-close" (click)="closeVoicePopup()" aria-label="Close voice input">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
              <div class="voice-popup-header">
                <ng-container *ngIf="!productVoiceActive">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>
                  <span>Listening…</span>
                </ng-container>
                <ng-container *ngIf="productVoiceActive">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                  <span>Say a product name…</span>
                </ng-container>
                <span class="voice-popup-rec"><span class="rec-dot"></span>REC</span>
              </div>
              <div class="voice-wave" aria-hidden="true">
                <span></span><span></span><span></span><span></span><span></span>
                <span></span><span></span><span></span><span></span>
              </div>
              <div class="voice-transcript" [class.has-text]="!!liveTranscript">{{ liveTranscript }}</div>
              <div class="voice-lang-row">
                <button type="button" class="voice-lang-btn" [class.open]="langPickerOpen"
                        [disabled]="isTranscribing"
                        (click)="langPickerOpen = !langPickerOpen"
                        title="Speech recognition language">
                  <span class="voice-lang-flag">{{ voiceLangFlag }}</span>
                  <span class="voice-lang-text">{{ voiceLangLabel }}</span>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                </button>
                <div class="voice-lang-menu" *ngIf="langPickerOpen">
                  <button type="button" *ngFor="let l of voiceLangs"
                          class="voice-lang-opt" [class.active]="voiceLang === l.code"
                          (click)="selectVoiceLang(l.code)">
                    <span class="voice-lang-flag">{{ l.flag }}</span>
                    <span>{{ l.label }}</span>
                  </button>
                </div>
              </div>
              <div class="voice-popup-actions">
                <button type="button" class="voice-popup-stop" [disabled]="isTranscribing" (click)="closeVoicePopup()">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="6" width="12" height="12" rx="2"/></svg>
                  Cancel
                </button>
                <button type="button" class="voice-popup-go"
                        [disabled]="isTranscribing"
                        (click)="confirmVoice()">
                  <ng-container *ngIf="isTranscribing">
                    <span class="voice-spinner" aria-hidden="true"></span>
                    Transcribing…
                  </ng-container>
                  <ng-container *ngIf="!isTranscribing && !productVoiceActive">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>
                    Send
                  </ng-container>
                  <ng-container *ngIf="!isTranscribing && productVoiceActive">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    Search
                  </ng-container>
                </button>
              </div>
            </div>

            <!-- Follow-up chips: collapsed to 2 by default; "+N more" pill expands -->
            <div class="sw-chips" *ngIf="suggestions.length > 0 && !isStreaming && !isLoading"
                 [attr.data-expanded]="chipsExpanded || null">
              <button class="sw-chip" *ngFor="let c of visibleChips" (click)="selectSuggestion(c)" [title]="c">{{ c }}</button>
              <button class="sw-chip sw-chip-more" *ngIf="hiddenChipsCount > 0 || chipsExpanded"
                      (click)="toggleChipsExpanded()"
                      [attr.aria-expanded]="chipsExpanded">
                {{ chipsExpanded ? 'Show less' : '+' + hiddenChipsCount + ' more' }}
              </button>
            </div>
            <div class="sw-composer" [attr.data-focused]="composerFocused || null">
              <!-- Staged photo preview — shown above the textarea when an image is attached. -->
              <div class="photo-preview" *ngIf="pendingPhotoDataUrl">
                <img [src]="pendingPhotoDataUrl" alt="Attached photo" />
                <div class="photo-preview-meta">
                  <span class="photo-preview-name">{{ pendingPhotoName || 'Photo' }}</span>
                  <span class="photo-preview-hint">Tap send to OCR</span>
                </div>
                <button type="button" class="photo-preview-remove"
                        (click)="removePendingPhoto()"
                        title="Remove attached photo"
                        aria-label="Remove attached photo">×</button>
              </div>
              <!-- Staged document chip (PDF/Word/Excel) — extracted + relevance-checked server-side. -->
              <div class="doc-chip" *ngIf="pendingDocName || docBusy">
                <span class="doc-chip-spin" *ngIf="docBusy"></span>
                <span class="doc-chip-icon" *ngIf="!docBusy">📄</span>
                <div class="doc-chip-meta">
                  <span class="doc-chip-name">{{ pendingDocName || 'Document' }}</span>
                  <span class="doc-chip-hint" *ngIf="docBusy">Reading &amp; checking…</span>
                  <span class="doc-chip-hint ready" *ngIf="!docBusy && pendingDocId">Ready{{ docTruncated ? ' · long file, trimmed' : '' }} — tap send</span>
                </div>
                <button type="button" class="photo-preview-remove" *ngIf="!docBusy"
                        (click)="removePendingDoc()" title="Remove document" aria-label="Remove document">×</button>
              </div>
              <!-- Document rejection / error notice. -->
              <div class="doc-error" *ngIf="docError">
                <span>{{ docError }}</span>
                <button type="button" (click)="docError = null" aria-label="Dismiss">×</button>
              </div>
              <textarea
                #composerEl
                [(ngModel)]="inputText"
                (focus)="composerFocused = true"
                (blur)="composerFocused = false"
                (keydown)="onKeyDown($event)"
                (input)="autoResize($event)"
                [disabled]="isStreaming || isLoading"
                placeholder="Ask Shaji anything…"
                rows="1"
                maxlength="2000"></textarea>
              <div class="sw-composer-bar">
                <!-- OCR / attach photo: opens camera on mobile, file picker on desktop. -->
                <input type="file" #photoInput accept="image/*" capture="environment"
                       style="display:none" (change)="onPhotoAttached($event)" />
                <button type="button"
                        class="cmp-btn photo-btn"
                        [class.has-photo]="!!pendingPhotoDataUrl"
                        [disabled]="isLoading || isStreaming"
                        [title]="pendingPhotoDataUrl ? 'Photo attached — tap send to OCR' : 'Take photo / attach invoice for OCR'"
                        (click)="photoInput.click()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>
                  </svg>
                </button>
                <!-- Attach a document (PDF / Word / Excel) — extracted + relevance-gated server-side. -->
                <input type="file" #docInput
                       accept=".pdf,.doc,.docx,.xls,.xlsx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.ms-excel"
                       style="display:none" (change)="onDocAttached($event)" />
                <button type="button"
                        class="cmp-btn doc-btn"
                        [class.has-doc]="!!pendingDocId"
                        [disabled]="isLoading || isStreaming || docBusy"
                        [title]="pendingDocId ? 'Document attached — tap send' : 'Attach a PDF, Word or Excel document'"
                        (click)="docInput.click()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
                </button>
                <button type="button"
                        class="cmp-btn mic-btn"
                        [class.listening]="isListening && !productVoiceActive"
                        [class.has-voice]="voiceSupported"
                        [disabled]="!voiceSupported || isLoading || isStreaming"
                        [title]="!voiceSupported ? 'Voice input not supported in this browser' : (isListening && !productVoiceActive ? 'Stop listening' : 'Dictate a message')"
                        (click)="toggleListening()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>
                </button>
                <!-- Product-voice search button removed from here. The startProductVoice()
                     method and productVoiceActive state remain in the TS for reuse later. -->
                <div class="spacer"></div>
                <button
                  class="sw-send"
                  [attr.data-state]="(isLoading || isStreaming) ? 'streaming' : (inputText.trim() ? 'ready' : 'idle')"
                  (click)="(isLoading || isStreaming) ? stop() : send()"
                  [disabled]="!isLoading && !isStreaming && !inputText.trim()"
                  [attr.aria-label]="(isLoading || isStreaming) ? 'Stop' : 'Send'">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" data-icon="arrow">
                    <path d="M12 19V5M5 12l7-7 7 7"/>
                  </svg>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" data-icon="stop">
                    <rect x="7" y="7" width="10" height="10" rx="2"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Footer -->
      <div class="sw-foot">
        <img src="assets/img/shaji-brand.png" alt="" />
        <span>Powered by <strong>Shaji AI</strong></span>
      </div>

    </div>
  </div>

  <!-- Tap-to-drill options popover -->
  <ng-container *ngIf="drillMenu.visible">
    <div class="ai-drill-backdrop" (click)="closeDrill()"></div>
    <div class="ai-drill-menu" [style.left.px]="drillMenu.x" [style.top.px]="drillMenu.y">
      <div class="ai-drill-menu-head" [title]="drillMenu.value">{{ drillMenu.value }}</div>
      <button type="button" class="ai-drill-opt" *ngFor="let o of drillMenu.options" (click)="runDrill(o)">{{ o.label }}</button>
    </div>
  </ng-container>
</ng-container>
